import StoneListTable from './StoneListTable'

export default StoneListTable
